export default "__VITE_ASSET__BId_jgcd__";